import styled, { css } from 'styled-components';

// Shared between buy-it-again-simple-tile.tsx and buy-it-again-substitute-modal.tsx --
// mirrors the strain-type pill and potency text styling from src/components/product-card-v2
// (CardStrainType / CardPotency) so OOS/substitute cards match in-stock product cards.

export const StrainBadge = styled.span`
  background: #e3e7e9;
  border-radius: 12px;
  color: #2c3236;
  display: inline-block;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 8px;
`;

export const PotencyText = styled.span`
  color: #646d72;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
`;

// Shared by every solid white "pill"/circle overlay button in this carousel family (quick-add,
// "View similar", "Past orders") so they all look and behave the same. Matches the hover/focus
// treatment already used on the app's other white circular buttons — see CircleButton in
// src/components/core/button/circle-button.tsx.
export const overlayButtonStyles = css`
  align-items: center;
  appearance: none;
  background: var(--dcm-color-body-bg, #fff);
  border: none;
  box-shadow: var(--dcm-buy-it-again-overlay-button-shadow, 0 1px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: background-color 200ms, box-shadow 200ms;

  &:hover {
    background-color: var(--dcm-circle-button-hover-bg, ${({ theme }) => theme.colors.grey[95]});
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
    outline-offset: 2px;
  }
`;
